import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';
import { xpApi } from './xpApi';

export const historyApi = createApi({
  reducerPath: 'historyApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['History'],
  endpoints: (builder) => ({
    getHistory: builder.query({
      query: ({ page = 1, perPage = 24 } = {}) =>
        `/history?page=${page}&per_page=${perPage}`,
      providesTags: ['History'],
    }),
    addToHistory: builder.mutation({
      query: ({ materialId, episode = 0 }) => ({
        url: '/history',
        method: 'POST',
        body: { material_id: materialId, episode },
      }),
      // After a watch is recorded, invalidate XP in its own API slice
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(xpApi.util.invalidateTags(['XP']));
        } catch {
          // fire-and-forget — ignore errors
        }
      },
    }),
    deleteFromHistory: builder.mutation({
      query: (materialId) => ({
        url: `/history/${materialId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['History'],
    }),
    clearHistory: builder.mutation({
      query: () => ({
        url: '/history',
        method: 'DELETE',
      }),
      invalidatesTags: ['History'],
    }),
  }),
});

export const {
  useGetHistoryQuery,
  useAddToHistoryMutation,
  useDeleteFromHistoryMutation,
  useClearHistoryMutation,
} = historyApi;
